export default "__VITE_ASSET__CcrtRiiy__"